import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/tjh-logo.png";

// Official TJH wordmark (white letters + green dot) — best on dark surfaces.
export default function Logo({ className = "h-9 sm:h-10" }) {
  return (
    <Link to="/" className="inline-flex items-center select-none" aria-label="The Jackson House" data-cursor="hover">
      <img src={logo} alt="The Jackson House" className={`${className} w-auto object-contain`} />
    </Link>
  );
}
